import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';

export class OneClickDeliveryInstructionsProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    return this.store.select(getOneClickSelectedOrder).pipe(
      filter(order => !!order),
      map(order => {
        return `${order.instructions}`;
      }),
    );
  }
}
